import { useState, useRef, useEffect } from 'react';
import { useLanguage, Language } from '../../contexts/LanguageContext';

const languages: { code: Language; name: string; nativeName: string }[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
];

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLanguage = languages.find(l => l.code === language);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 px-2 py-1.5 sm:px-3 sm:py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-global-line text-teal-600 text-sm sm:text-lg"></i>
        <span className="hidden sm:inline text-sm font-medium text-gray-700">{currentLanguage?.nativeName}</span>
        <i className={`ri-arrow-down-s-line text-gray-500 transition-transform text-xs sm:text-base ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-32 sm:w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                setIsOpen(false);
              }}
              className={`w-full px-3 py-2 text-left text-xs sm:text-sm hover:bg-teal-50 transition-colors cursor-pointer flex items-center justify-between ${
                language === lang.code ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
              }`}
            >
              <span>{lang.nativeName}</span>
              {language === lang.code && <i className="ri-check-line text-teal-600 text-sm"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
